import { ACTIONS, DROPZONE_STATUS, GAME_ID } from '../dataManagement/Constants';
import { makeShuffledArray } from '../lib/utilityFunctions';

const initialState = {
  isShowingResult: false,
  selectedWord: {
    id: -1,
    text: ' ',
  },
  dropzones: [],
  clickables: [],
};

const NO_WORD = {
  id: -1,
  text: ' ',
};

const selectedWord = (state = initialState.selectedWord, action) => {
  switch (action.type) {
    case ACTIONS.SELECT_PRACTICE_WORD:
      return {
        ...state,
        id: action.payload.selectedWordId,
        text: action.payload.selectedWord,
      };

    case ACTIONS.ATTACH_WORD_TO_DROPZONE:
      return { ...NO_WORD };

    default:
      return state;
  }
};

const dropzone = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS.ATTACH_WORD_TO_DROPZONE:
      if (state.id === action.payload.id) {
        return {
          ...state,
          attachedWord: action.payload.selectedWord,
          isAvailable: false,
          status: DROPZONE_STATUS.USED,
          isCorrect: state.id === action.payload.selectedWord.id,
        };
      }
      break;

    case ACTIONS.DETACH_WORD_FROM_DROPZONE:
      if (state.id === action.payload.id) {
        return {
          ...state,
          attachedWord: NO_WORD,
          isAvailable: true,
          status: DROPZONE_STATUS.AVAILABLE,
          isCorrect: false,
        };
      }
      break;

    case ACTIONS.SHOW_RESULT:
      if (action.payload) {
        if (state.isCorrect) {
          return {
            ...state,
            status: DROPZONE_STATUS.CORRECT,
          };
        }
        return {
          ...state,
          status: DROPZONE_STATUS.INCORRECT,
        };
      }
      break;
    default:
      return state;
  }
  return state;
};

const clickable = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS.SELECT_PRACTICE_WORD:
      return {
        ...state,
        isSelected: state.id === action.payload.selectedWordId,
      };

    case ACTIONS.ATTACH_WORD_TO_DROPZONE:
      if (state.id === action.payload.selectedWord.id) {
        return {
          ...state,
          isAvailable: false,
        };
      }
      return state;

    case ACTIONS.DETACH_WORD_FROM_DROPZONE:
      if (state.id === action.payload.attachedWordId) {
        return {
          ...state,
          isAvailable: true,
          isSelected: false,
        };
      }
      return state;

    default:
      return state;
  }
};

const practiceViewData = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case ACTIONS.INIT_SHADES_SESSION:
      return initialState;

    case ACTIONS.CREATE_PRACTICE_DATA:
      return {
        ...state,
        clickables: createClickables(action.payload),
        dropzones: createDropzones(action.payload),
      };

    case ACTIONS.SELECT_PRACTICE_WORD:
      return {
        ...state,
        clickables: state.clickables.map(c => clickable(c, action)),
        selectedWord: selectedWord(state.selectedWord, action),
      };

    case ACTIONS.SHOW_RESULT:
      return {
        ...state,
        isShowingResult: action.payload,
        dropzones: state.dropzones.map(d => dropzone(d, action)),
      };

    default:
      return {
        ...state,
        dropzones: state.dropzones.map(d => dropzone(d, action)),
        clickables: state.clickables.map(c => clickable(c, action)),
        selectedWord: selectedWord(state.selectedWord, action),
      };
  }
};

export default practiceViewData;

// HELPER FUNCTIONS ------------------------------------------------------------
let clickableKey = 0;
const createClickables = payload =>
  makeShuffledArray(payload.map((wordData, i) => ({
    id: i,
    word: wordData.word,
    isAvailable: true,
    isSelected: false,
    key: clickableKey++,
  })));

let dropzoneKey = 0;
const createDropzones = payload =>
  makeShuffledArray(payload.map((wordData, i) => ({
    id: i,
    word: wordData.word,
    phrase: wordData.practice,
    isAvailable: true,
    attachedWord: NO_WORD,
    key: dropzoneKey++,
    status: DROPZONE_STATUS.AVAILABLE,
    isCorrect: false,
  })));
